/** Largeur gauche par défaut du split Documents (%). */
export const U3121_DOCUMENTS_SPLIT_DEFAULT_LEFT_PCT = 40;

/** Borne min panneau arbre/liste (px). */
export const U3121_DOCUMENTS_SPLIT_MIN_LEFT_PX = 280;

/** Borne min panneau aperçu (px). */
export const U3121_DOCUMENTS_SPLIT_MIN_PREVIEW_PX = 320;

const STORAGE_KEY_PREFIX = 'u3121_documentsSplitLeftPct';

/**
 * Clé localStorage scoped user/org (fallback globale si non authentifié).
 */
export function u3121DocumentsSplitStorageKey(
  userName?: string | null,
  organizationId?: string | null
): string {
  if (userName?.trim()) {
    return `${STORAGE_KEY_PREFIX}_${userName.trim()}_${organizationId?.trim() || 'noorg'}`;
  }
  return STORAGE_KEY_PREFIX;
}

/**
 * Normalise une valeur persistée : nombre fini entre 5 et 95, sinon défaut 40.
 */
export function u3121NormalizeDocumentsSplitLeftPct(value: unknown): number {
  if (typeof value !== 'number' || !Number.isFinite(value)) {
    return U3121_DOCUMENTS_SPLIT_DEFAULT_LEFT_PCT;
  }
  if (value < 5 || value > 95) {
    return U3121_DOCUMENTS_SPLIT_DEFAULT_LEFT_PCT;
  }
  return value;
}

/**
 * Clamp la position de la poignée (px depuis le bord gauche du conteneur)
 * puis retourne le pourcentage gauche (0–100).
 */
export function u3121ClampDocumentsSplitLeftPercent(
  leftPx: number,
  containerWidth: number,
  minLeftPx: number = U3121_DOCUMENTS_SPLIT_MIN_LEFT_PX,
  minPreviewPx: number = U3121_DOCUMENTS_SPLIT_MIN_PREVIEW_PX
): number {
  if (!Number.isFinite(containerWidth) || containerWidth <= 0) {
    return U3121_DOCUMENTS_SPLIT_DEFAULT_LEFT_PCT;
  }
  if (!Number.isFinite(leftPx)) {
    return U3121_DOCUMENTS_SPLIT_DEFAULT_LEFT_PCT;
  }

  const maxLeft = Math.max(0, containerWidth - minPreviewPx);
  const effectiveMin = Math.min(Math.max(0, minLeftPx), maxLeft);
  const clamped = Math.min(Math.max(leftPx, effectiveMin), maxLeft);
  return (clamped / containerWidth) * 100;
}

/**
 * Convertit un % gauche en px pour un conteneur donné (après normalisation).
 */
export function u3121DocumentsSplitLeftPxFromPercent(
  leftPct: unknown,
  containerWidth: number
): number {
  if (!Number.isFinite(containerWidth) || containerWidth <= 0) {
    return 0;
  }
  const pct = u3121NormalizeDocumentsSplitLeftPct(leftPct);
  return (pct / 100) * containerWidth;
}
